export default __webpack_public_path__ + "static/media/Nose_5.adbf18d8.svg";